/**
 * Adoption Center module-details request/response shapes.
 * Mirrors backend/src/modules/adoption/adoption.validators.ts.
 */

export type AdoptionOrgType =
  | 'NGO'
  | 'ANIMAL_SHELTER'
  | 'RESCUE_ORG'
  | 'FOSTER_NETWORK';

export type AdoptionDesignation =
  | 'FOUNDER'
  | 'MANAGER'
  | 'COORDINATOR'
  | 'VOLUNTEER_HEAD';

export type YearBracket =
  | 'Y_2024'
  | 'Y_2023'
  | 'Y_2022'
  | 'Y_2021'
  | 'Y_2020'
  | 'OLDER';

export type AdoptionDetailsRequest = {
  organization_types: AdoptionOrgType[]; // 1..4 unique
  contact_person_name: string; // 2..120
  designation?: AdoptionDesignation;
  animals_available?: number; // 0..10000 integer
  max_capacity?: number; // 0..10000 integer
  volunteer_count?: number; // 0..10000 integer
  year_established?: YearBracket;
  staff_count: number; // 1..10000 integer
};

export type AdoptionDetailsResponse = {
  id: string;
  vendor_profile_id: string;
  organization_types: AdoptionOrgType[];
  contact_person_name: string;
  designation: AdoptionDesignation | null;
  animals_available: number | null;
  max_capacity: number | null;
  volunteer_count: number | null;
  year_established: YearBracket | null;
  staff_count: number;
  created_at: string;
  updated_at: string;
};

export const ADOPTION_ORG_TYPE_OPTIONS: Array<{
  value: AdoptionOrgType;
  label: string;
}> = [
  { value: 'NGO', label: 'NGO' },
  { value: 'ANIMAL_SHELTER', label: 'Animal shelter' },
  { value: 'RESCUE_ORG', label: 'Rescue org' },
  { value: 'FOSTER_NETWORK', label: 'Foster network' },
];

export const ADOPTION_DESIGNATION_OPTIONS: Array<{
  value: AdoptionDesignation;
  label: string;
}> = [
  { value: 'FOUNDER', label: 'Founder' },
  { value: 'MANAGER', label: 'Manager' },
  { value: 'COORDINATOR', label: 'Coordinator' },
  { value: 'VOLUNTEER_HEAD', label: 'Volunteer head' },
];

export const YEAR_BRACKET_OPTIONS: Array<{ value: YearBracket; label: string }> = [
  { value: 'Y_2024', label: '2024' },
  { value: 'Y_2023', label: '2023' },
  { value: 'Y_2022', label: '2022' },
  { value: 'Y_2021', label: '2021' },
  { value: 'Y_2020', label: '2020' },
  { value: 'OLDER', label: 'Older than 2020' },
];
